import { TPolicyLinkBlock } from '@/components/policyLinkBlock/types'
import { getPolicy } from '@/components/policyLinkBlock/utils'
import { TextHTML } from '@/components/typography'

const defaultPolicyTemplate: TPolicyLinkBlock = {
  text: 'By purchasing, you agree to {tos} and {privacyPolicy}, {refundPolicy}.',
  tos: 'T&Cs',
  privacyPolicy: 'Privacy Policy',
  refundPolicy: 'Refund Policy',
}

export const PaymentScreenPolicy = () => {
  const policyText = getPolicy({
    translationKey: 'paymentScreenPage.purchasePolicy',
    defaultPolicyTemplate: defaultPolicyTemplate,
  })
  return (
    <div className="policy-container">
      <TextHTML title={policyText} />
    </div>
  )
}
